<template>
  <ErrorDisplay v-if="store.error" :message="store.error.message" :loading="store.loading" @retry="store.fetch" />
  <Loading v-else-if="store.loading" />
  <v-select
    v-else
    :variant="!showLabel ? 'solo' : undefined"
    :density="!showLabel ? 'compact' : 'default'"
    label="Art"
    hide-details
    class="mt-3 mb-2"
    v-model="internalValue"
    item-title="Bezeichnung"
    item-value="Kurz"
    :items="store.data"
    :loading="store.loading"
    placeholder="--- Art wählen ---"
    :return-object="false"
    :rules="rules"
  />
</template>

<script lang="ts" setup>
import {useContactKindStore} from '@/store/contactKind';
import Loading from '@/components/Loading.vue';
import {computed} from 'vue';
import ErrorDisplay from './ErrorDisplay.vue';
const store = useContactKindStore();
store.fetch().catch(console.error);
const props = defineProps<{
    modelValue?: string
    showLabel?: boolean
    rules?: Array<(value: any) => true | string>
}>();

const emit = defineEmits({'update:modelValue': (data: string) => typeof data === 'string'});

const internalValue = computed({
  get() {
    return props.modelValue || '';
  },
  set(newVal: string) {
    emit('update:modelValue', newVal);
    return;
  },
});

defineExpose({
  store,
  internalValue,
  fetch,
  props,
  Loading,
  ErrorDisplay,
});
</script>
